import { render } from "./ScheduleAnnotationCreateEditModal.vue?vue&type=template&id=ddceb208"
import script from "./ScheduleAnnotationCreateEditModal.vue?vue&type=script&lang=js"
export * from "./ScheduleAnnotationCreateEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__